import React from "react";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NotAuthenticatedScreen = () => {
  return (
    <div className="not-authenticated-screen">
      <FontAwesomeIcon icon={faExclamationTriangle} className="icon" />
      <div>You must be logged in to access this page.</div>
    </div>
  )
}

export default NotAuthenticatedScreen;
